import { ReactNode } from 'react';
import { Timeline } from './timeline';
import { Material } from './material';

export type Session = {
  availableStartDate: Date;
  availableThroughDate: Date;
  curriculumId: string;
  getAvailableThroughMessage: (date: string) => ReactNode;
  isPreview: boolean;
  isScheduled: boolean;
  isThisWeek: boolean;
  issueId: string;
  issueName: string;
  materials: Material[];
  name: string;
  publishEndDate: string;
  publishStartDate: string;
  recommendedDate: Date;
  scheduledDate: Date;
  sessionId: string;
  sessionNumber: number;
  timelines: Timeline[];
  useDate?: boolean;
  volumeId?: string;
  description?: string;
  lockReason?: 'Trial' | 'SubscriptionSwitched' | 'SubscriptionExpiration';
  image?: string;
};

export const isLocked = (session: Session): boolean => {
  return Boolean(session.lockReason === 'Trial' || session.lockReason === 'SubscriptionSwitched');
  // Once we want to show a message for SubscriptionExpiration, we can get rid of the above line
  // and uncomment the one below.
  // return Boolean(session.lockReason);
};
